import { Link } from 'react-router-dom';

export default function ClinicalFooter() {
  return (
    <footer className="clinical-footer">
      <span>© {new Date().getFullYear()} Talo</span>
      <nav aria-label="Legal and support">
        <Link to="/terms-of-use">Terms of use</Link>
        <Link to="/terms-of-supply">Terms of supply</Link>
        <Link to="/privacy-policy">Privacy</Link>
        <a href="mailto:support@jointalo.com">Contact support</a>
      </nav>
    </footer>
  );
}
